import { Badge, BadgeColor } from "@/components/catalyst/badge";

export type BadgeCellItem = {
  label: string;
  color: BadgeColor;
  isHidden?: boolean;
};

export function BadgeCell({ badges }: { badges: BadgeCellItem[] }) {
  if (badges.length === 0) return null;

  return (
    <span className="space-x-1">
      {badges.map((badge, index) => {
        if (badge.isHidden) return null;
        return (
          <Badge key={index} color={badge.color}>
            {badge.label}
          </Badge>
        );
      })}
    </span>
  );
}
